import corpToReg from './corpToRegSchema';
import regToCorp from './regToCorpSchema';

export default {
  corpToReg,
  regToCorp,
};